export const UK_VAT = 'GB';
